import { useEffect, useState } from "react";
import "./style.css";
import supabase from "./supabase";

const initialFacts = [
  {
    id: 1,
    text: "React is being developed by Meta (formerly facebook)",
    source: "https://opensource.fb.com/",
    category: "technology",
    votesInteresting: 24,
    votesMindblowing: 9,
    votesFalse: 4,
    createdIn: 2021,
  },
  {
    id: 2,
    text: "Millennial dads spend 3 times as much time with their kids than their fathers spent with them. In 1982, 43% of fathers had never changed a diaper. Today, that number is down to 3%",
    source:
      "https://www.mother.ly/parenting/millennial-dads-spend-more-time-with-their-kids",
    category: "society",
    votesInteresting: 11,
    votesMindblowing: 2,
    votesFalse: 0,
    createdIn: 2019,
  },
  {
    id: 3,
    text: "Lisbon is the capital of Portugal",
    source: "https://en.wikipedia.org/wiki/Lisbon",
    category: "society",
    votesInteresting: 8,
    votesMindblowing: 3,
    votesFalse: 1,
    createdIn: 2015,
  },
];

const CATEGORIES = [
  { name: "technology", color: "#3b82f6" },
  { name: "science", color: "#16a34a" },
  { name: "finance", color: "#ef4444" },
  { name: "society", color: "#eab308" },
  { name: "entertainment", color: "#db2777" },
  { name: "health", color: "#14b8a6" },
  { name: "history", color: "#f97316" },
  { name: "news", color: "#8b5cf6" },
];

function App() {
  // * define state variable
  const [showForm, setShowForm] = useState(false); // In react we can't pass prop from child to parent component and as we need the in the app component and also in the header component that we need to declare the state variable here and not in the header component.so state is basically the current condition of the component and when we need it in another component , we need to pass it as a prop.and remember to declare the state variable in the parent component.

  const [facts, setFacts] = useState([]); // we are keeping it empty because until the data coming from the server we need to show the list empty instead of initialfacts.

  const [isLoading, setIsLoading] = useState(false); // this state is created to use loader function before the facts are loaded by set facts function and as soon as the facts are loaded we make it false so the loader function disappears. and when isloading function is true we basically call the loader function using ternary operator and when the facts are loaded from the server , inloading gets false value so its just display the FactList component.

  const [currentCategory, setCurrentCategory] = useState(`all`); // this state is created to render the fact list after filtering the current category. so basically on click on category buttons we change the currentCategory value to the currentCategory name and we use the changed currentCategory value with query.eq() and set it equals to category. remember as it is a useeffect hook , it will render once but as we want to render it every times the currentCategory change then we need to mention the currentCategory inside the empty array which is the second argument of useEffect hook.
  useEffect(
    function () {
      async function getFacts() {
        setIsLoading(true); // its for calling loader function before facts are loaded
        let query = supabase.from("Facts").select("*");

        if (currentCategory !== `all`) {
          query.eq(`category`, currentCategory);
        }
        const { data: Facts, error } = await query
          .order(`votesInteresting`, { ascending: false })
          .limit(1000);

        if (!error) {
          setFacts(Facts); // here we are passing the facts to the setFacts function which updates the state of the database.
        } else alert(`there is a problem in loading data`); // is if else state is for error handling.

        setIsLoading(false); // its for stopping the loader function so that the facts can be displayed.
      }
      getFacts();
    },
    [currentCategory]
  ); // we are using empty array  because with this array and useeffect hook the data will just render once when someone first loads the page
  return (
    <>
      <Header showForm={showForm} setShowForm={setShowForm} />

      {/* using state variable  */}
      {showForm ? (
        <FactForm setFacts={setFacts} setShowForm={setShowForm} />
      ) : null}

      {/*   here we are telling that if the state(Showform) is false then don't render the  <FactForm /> and as the default value is false so the the form keeps hidden but inside the button when the function triggers we just change the current state so the function rerender the component with true value and fact form appears but when we reclick the button then the function again returns the opposite value of the current state because not (!) sign , so the function rerender the component and the <FactForm/>> gets disappeared.    */}

      <main className="main">
        <CategoryFilter setCurrentCategory={setCurrentCategory} />
        {isLoading ? Loader() : <FactList facts={facts} setFacts={setFacts} />}
        {/* using isloading we call the loader function until facts are fetched , as the facts are fetched isloading gets false value and it stops calling the loader function and displays the fact list*/}
      </main>
    </>
    /* this are fragments in jsx we need those because a return keyword can't return multiple things that's why we use fragments to return multiple things */
  );
}

function Loader() {
  return <p className="message">Loading...</p>;
}

function Header({ showForm, setShowForm }) {
  const siteName = `Factz I Learned`;

  return (
    <header className="header">
      <div className="logo">
        <img src="logo.png" alt=" Today I learned logo" />
        <h1>{siteName}</h1>
      </div>
      <button
        className="btn btn-large btn-open"
        // * Updating state variable
        onClick={() => setShowForm((form) => !form)}
      >
        {showForm ? `Close` : `Share A fact`}
      </button>
    </header>
  );
}
function isValidURL(string) {
  var res = string.match(
    /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
  );
  return res !== null;
}

function FactForm({ setFacts, setShowForm }) {
  const [text, setText] = useState("");
  const [source, setSource] = useState("");
  const [category, setCategory] = useState("");
  const textLength = text.length; // for the letter counting span.
  const [isUploading, setIsUploading] = useState(false); // this state is created to disable the form when new fact is uploading to the server.
  async function formSubmit(e) {
    //preventing the page from reload
    e.preventDefault();
    console.log(text, source, category);
    // console.log(e);// here e is basically the event which occurs when the form is submitted , this event refreshes the page by default , so that's why we need that event so we can stop that event to reload the page using e.preventDefault() method.

    // checking if data is valid.so using that we can create a new object
    if (text && category && isValidURL(source) && textLength <= 200) {
      console.log(`there is valid data`);

      // creating new object
      // const newFact = {
      //   id: Math.floor(Math.random() * 10000000000),
      //   text,
      //   source,
      //   category,
      //   votesInteresting: 0,
      //   votesMindblowing: 0,
      //   votesFalse: 0,
      //   createdIn: new Date().getFullYear(),
      // };
      // * adding data to supabase and also updating to the frontend

      setIsUploading(true);

      const { data: newFact, error } = await supabase
        .from("Facts")
        .insert([{ text, source, category }])
        .select(`*`); //select is important to get the new fact back after inserting it to supabase

      setIsUploading(false);

      // adding the new data to the fact list UI
      if (!error) {
        setFacts((facts) => [newFact[0], ...facts]);
      } // facts is the current state here which is the initialfacts object

      //reset the form
      setText("");
      setSource("");
      setCategory("");

      // closing the form
      setShowForm(false);
    }
  }

  return (
    <form action="" className="fact-form " onSubmit={formSubmit}>
      {/*this function is necessary of form submission and we don't call the function , we need to let react call the function on submit*/}
      <input
        type="text"
        placeholder="Share a fact with the world..."
        value={text}
        onChange={(el) => setText(el.target.value)}
        disabled={isUploading}
      />
      <span>{200 - textLength}</span>
      <input
        type="text"
        placeholder="Trustworthy Source"
        value={source}
        onChange={(el) => setSource(el.target.value)}
        disabled={isUploading}
      />
      <select
        value={category}
        onChange={(el) => setCategory(el.target.value)}
        disabled={isUploading}
      >
        {/*we use this kind of event handler functions for input elements we need to specify current state using value and changing state using on onchange function. */}

        <option value="">Choose Category</option>
        {CATEGORIES.map((cat) => (
          <option key={cat.name} value={cat.name}>
            {cat.name.toUpperCase()}
          </option>
        ))}
      </select>
      <button className="btn btn-large">Post</button>
    </form>
  );
}

function CategoryFilter({ setCurrentCategory }) {
  return (
    <aside>
      <ul>
        <li className="categories">
          <button
            className="btn btn-all-categories"
            onClick={() => setCurrentCategory(`all`)}
          >
            All
          </button>
        </li>
        {CATEGORIES.map((cat) => {
          return (
            <li key={cat.name} className="categories">
              <button
                className="btn btn-categories"
                style={{ backgroundColor: cat.color }}
                onClick={() => setCurrentCategory(cat.name)}
              >
                {cat.name}
              </button>
            </li>
          );
        })}
      </ul>
    </aside>
  );
}
function FactList({ facts, setFacts }) {
  if (facts.length === 0)
    return (
      <p className="message">
        No facts has been created in this category. Create first one😁😁😉{" "}
      </p>
    ); // as after returning something react stop execution why we don't need to write a else block for the below code
  return (
    <section>
      <ul className="fact-list">
        {facts.map((fact) => {
          return <Fact key={fact.id} fact={fact} setFacts={setFacts} />; // fact is prop here so we can pass fact argument using the prop. and remember when you are using prop then you need to mention key name here.Here <Fact/> is the list component .
        })}
      </ul>
    </section>
  );
}

function Fact({ fact, setFacts }) {
  const [isUpdating, setIsUpdating] = useState(false);
  const disputed =
    fact.votesInteresting + fact.votesMindblowing < fact.votesFalse;
  // * this function is created to update vote buttons
  async function handleVotes(columnName) {
    setIsUpdating(true);
    const { data: updatedFact, errors } = await supabase
      .from("Facts")
      .update({ [columnName]: fact[columnName] + 1 })
      .eq("id", fact.id)
      .select(`*`);
    setIsUpdating(false);
    // console.log(updatedFact);

    if (!errors)
      setFacts((facts) =>
        facts.map((f) => (f.id === fact.id ? updatedFact[0] : f))
      );
  }
  return (
    <li className="facts">
      {disputed ? <span className="disputed">[❌DISPUTED]</span> : null}
      <p>
        {fact.text}
        <a
          className="source"
          href={fact.source}
          target="_blank"
          rel="noopener noreferrer"
        >
          (source)
        </a>
      </p>
      <span
        className="tags"
        style={{
          backgroundColor: CATEGORIES.find((cat) => {
            return cat.name === fact.category;
          }).color,
        }}
      >
        {fact.category}
      </span>
      <div className="vote-buttons">
        <button
          onClick={() => handleVotes(`votesInteresting`)}
          disabled={isUpdating}
        >
          👍 {fact.votesInteresting}
        </button>
        {/* this onclick event calls handleVote function to update votes */}
        <button
          onClick={() => handleVotes(`votesMindblowing`)}
          disabled={isUpdating}
        >
          🤯 {fact.votesMindblowing}
        </button>
        <button onClick={() => handleVotes(`votesFalse`)} disabled={isUpdating}>
          ⛔️ {fact.votesFalse}
        </button>
      </div>
    </li>
  );
}

//this Countertest component was made for learning the Usestate
function CounterTest() {
  const [count, setCount] = useState(34.5); // it will be the default value,
  console.log(`rendering...`);
  {
    /*when ever user clicks the button the setCount function get triggered and it rerender the full component CounterTest with the updated state  */
  }
  return (
    <>
      <span style={{ fontSize: `48px` }}>{count}</span>
      <button
        className="btn btn-large"
        onClick={() => setCount((currentCount) => currentCount * 2)}
      >
        {/*  // it will be the default value */}
        +2
      </button>
    </>
  );
}

export default App;
